import { Skeleton } from 'opensolar-ui'
import { ProductTileLayout } from './ProductTileLayout'

export const ProductLoadingTile = () => {
  return (
    <ProductTileLayout
      Thumb={<Skeleton width={216} height={160} style={{ display: 'block' }} />}
      BulkRow={false}
      DescriptionRow={<Skeleton width="100%" height={60} />}
      PricingRow={<Skeleton width="100%" height={40} />}
      DistributorRow={<Skeleton width={169} height={40} />}
      ConnectRow={<Skeleton width={145} height={20} />}
      Action={<Skeleton width="100%" height={40} />}
    />
  )
}
